import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

interface LoadingSpinnerProps {
  overlay?: boolean;
  fullHeight?: boolean;
  message?: string;
}

export const LoadingSpinner = ({
  overlay = false,
  fullHeight = false,
  message,
}: LoadingSpinnerProps) => {
  const theme = useTheme();

  if (overlay) {
    const isDark = theme.palette.mode === "dark";
    return (
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          backgroundColor: isDark
            ? "rgba(18, 18, 18, 0.6)"
            : "rgba(255, 255, 255, 0.65)",
          backdropFilter: "blur(3px)",
          zIndex: 1000,
        }}
      >
        <CircularProgress />
        {message && (
          <Typography variant="body2" color="text.secondary" fontWeight="medium">
            {message}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: fullHeight ? "100%" : "auto",
        width: "100%",
      }}
    >
      <CircularProgress />
    </Box>
  );
};
